export default function () {
  // Trick for router dependency manager
  // It's require to do not load ProfileModel in main bundle
  let profileDataPromiseTempResolve = null;
  const profileDataPromiseTemp = new Promise((resolve) => {
    profileDataPromiseTempResolve = resolve;
  });
  return {
    profileModel: {},
    profileDataPromiseTemp,
    profileDataPromiseTempResolve,
  };
}
